<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IN8/IN8.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IN 8.0 座舱域控制器</div>
                <div class="detail-banner-desc">
                    集成了车载远程信息处理器（TBOX）以及多屏交互、3D 车模联动、智能驾驶交互和生态应用等功能；<br />
                    设有 Type-A 和 Type-C 接口，支持 USB 音视频播放和 Switch 游戏投屏功能；<br />
                    单芯片上运行着 Linux（仪表）+ Linux（TBOX）+ Android（IVI）系统，集成了多显示屏、多摄像头、紧急呼叫（Ecall）、多种形式桌面、3D 车模交互、在线导航、语音识别等功能。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            搭载MTK8676全新数字座舱平台<br />
                        </div>
                        <div>
                            单颗芯片支持多操作系统（Linux/Linux/Android）<br />
                        </div>
                        <div>
                            支持多达4个显示器，11路摄像头，4路模拟麦克风，12路数字麦克风<br />
                        </div>
                        <div>
                            支持4路100M/1路1000M以太网，3路CAN(FD)， 1路LIN<br />
                        </div>
                        <div>
                            支持USB 2.0/3.0, WiFi 6E, BT 5.3<br />
                        </div>
                        <div>
                            支持全栈手机互联
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN8/IN8-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">4nm</div>
                                    <div class="k">制程</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">170K DMIPS</div>
                                    <div class="k">CPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1800 GFLOPS</div>
                                    <div class="k">GPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">20 TOPS</div>
                                    <div class="k">NPU</div>
                                </div>
                                
                                <div class="spec-item">
                                    <div class="v">Up to 4</div>
                                    <div class="k">显示屏</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">16/24G + 128/256G</div>
                                    <div class="k">存储</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1*1000 Base-T1+ 4*100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>
                                
                                <div class="spec-item spec-item-last">
                                    <div class="v">5G NR: SA/NSA、4G:TDD/FDD LTE</div>
                                    <div class="k">4G&5G网络</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">GPS/Beidou/Glonass/Galileo</div>
                                    <div class="k">GNSS</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.3、Vice BT: BT5.2 & BLE、WIFI6 & WIFI6E</div>
                                    <div class="k">蓝牙WIFI</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">1*1000 Base-T1+ 4*100 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>
                                
                                <div class="spec-item spec-item-last">
                                    <div class="v">5G NR: SA/NSA、4G:TDD/FDD LTE</div>
                                    <div class="k">4G&5G网络</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">GPS/Beidou/Glonass/Galileo</div>
                                    <div class="k">GNSS</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.3、Vice BT: BT5.2 & BLE、WIFI6 & WIFI6E</div>
                                    <div class="k">蓝牙WIFI</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN8/IN8-1.jpg" alt="200-1-02">
                    </div>
                </div> -->

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'IN 8.0 座舱域控制器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/IN8.html'
};

import { createApp } from 'vue';
import App from './IN8.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IN8.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
